import React, { useState, useEffect } from "react";

import { Flex, Box, Text, HStack, Icon, Image } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Information from "../Information";

import { FiliacaoTableVisualizacao } from "../../../pages/Criancas/Filiacao/TableVisualizacao";
import { generateAddressFiliacao } from "../../../utils/generateAddressFiliacao";

import { TableDocumentacao } from "../../../pages/Criancas/Documentacao/Table";
import { FaDownload } from "react-icons/fa";
import { intervalToDuration, format } from "date-fns";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";

export const DadosPrincipais = ({
  roleKeycloack,
  user,
  data,
  idCrianca,
  imagem,
  setImagem,
  columnsRegistro,
  columnsIdentidade,
  columnsCPF,
  dataDocumentacao,
  ocultarDocumentacao,
}) => {
  const permissaoServico =
    roleKeycloack.includes(criancaFunc.visualizarTudo) ||
    roleKeycloack.includes(servicoAcolhimentoFunc.visualizarPartePPCAAM) ||
    roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
    roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
    ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
      roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
      user?.orgaoExterno?.includes(data?.servicoAcolhimento?.idPessoaJuridica));
  const [temRiscoVidaInfo, setTemRiscoVidaInfo] = useState(false);

  useEffect(() => {
    if (
      data?.movimentacoes[0]?.idMovimento === 1 ||
      data?.movimentacoes[0]?.idMovimento === 2
    ) {
      const movimentacoes = data?.movimentacoes || [];

      for (const mov of movimentacoes) {
        if (mov?.idMovimento === 3 || !mov?.idMovimento) {
          setTemRiscoVidaInfo(mov?.riscoVidaMotivoSituacao === "S");
          break;
        }
      }
    }
  }, [data?.movimentacoes]);

  const columnsCTPS = [
    {
      Header: "Número da CTPS",
      accessor: "numeroCtps",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
    {
      Header: "Série",
      accessor: "serieCtps",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
    {
      Header: "Data da Expedição",
      accessor: "dataExpedicaoCtps",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Arquivo",
      accessor: "ctps",
      Cell: (props) => {
        return (
          <span>
            {props.value && (
              <Icon
                aria-label="Download"
                color="#006064"
                as={FaDownload}
                boxSize="18px"
                _hover={{ cursor: "pointer" }}
              />
            )}
          </span>
        );
      },
    },
  ];

  const columns = [
    {
      Header: "Vínculo",
      accessor: "tipoFiliacao",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        return <Text wordBreak={"break-word"}>{props.value}</Text>;
      },
    },
    {
      Header: "CPF",
      accessor: "cpf",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Endereço",
      accessor: "endereco",
      sortType: (rowA, rowB, id, desc) => {
        const enderecoA = generateAddressFiliacao(rowA.original);
        const enderecoB = generateAddressFiliacao(rowB.original);

        return enderecoA.localeCompare(enderecoB, "pt-BR");
      },
      Cell: (props) => {
        return <span>{generateAddressFiliacao(props.row.original)}</span>;
      },
    },
    {
      Header: "Observações",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return (
          <span>
            {props?.value?.falecido === "S"
              ? "Falecido"
              : props?.value?.idCriancaFiliacaoAcolhido
              ? "Acolhido(a)"
              : ""}
          </span>
        );
      },
    },
  ];

  const columnsCartaoNacionalSUS = [
    {
      Header: "Nº do Cartão do SUS",
      accessor: "numeroCartaoSus",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
  ];

  const columnsNumeroIdentidadeSocial = [
    {
      Header: "Número de Identificação Social",
      accessor: "numeroIdentidadeSocial",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
  ];
  let primeiraMovimentacao;

  if (data?.movimentacoes && data?.movimentacoes.length > 0) {
    const movimentacoesComData = data.movimentacoes.filter(
      (item) => item.ordem
    );

    if (movimentacoesComData.length > 0) {
      movimentacoesComData.sort((a, b) => b.ordem - a.ordem);

      primeiraMovimentacao = movimentacoesComData[0];
    }
  }

  return data ? (
    <HStack alignItems="flex-start">
      <Box
        display="block"
        bgColor="#fff"
        px="10px"
        py="20px"
        borderRadius="16px"
        w="100%"
        minW={"200px"}
        maxW={"205px"}
      >
        <Flex flexDir="column" alignItems="center" justifyContent="center">
          {!!imagem ? (
            <Image
              borderRadius="full"
              boxSize="135px"
              fit="cover"
              src={imagem + "?" + Date.now()}
              onError={() => setImagem("")}
            />
          ) : (
            <Box boxSize="135px" bgColor="#C4C4C4" borderRadius="full" />
          )}
          <Text
            mt="10px"
            color="#000"
            fontWeight={700}
            fontSize="16px"
            lineHeight="21.6px"
            w={"100%"}
          >
            {data?.nome} {data.nomeSocial ? " / " + data.nomeSocial : ""}
          </Text>
        </Flex>
        <Box display="block">
          <Information
            title="Data da Foto:"
            information={
              data?.dataFoto ? format(data?.dataFoto, "dd/MM/yyyy") : ""
            }
          />
          <Information
            title="Situação:"
            information={
              primeiraMovimentacao
                ? primeiraMovimentacao.motivoSituacao &&
                  primeiraMovimentacao.motivoSituacao.tipoSituacao.descricao ===
                    "Acolhido"
                  ? "Acolhido"
                  : primeiraMovimentacao.motivoSituacao &&
                    primeiraMovimentacao.motivoSituacao.tipoSituacao
                      .descricao === "Desligado"
                  ? "Desligado"
                  : !primeiraMovimentacao.motivoSituacao &&
                    !primeiraMovimentacao.movimentoMovimentacao
                  ? "Pendente"
                  : !primeiraMovimentacao.motivoSituacao &&
                    primeiraMovimentacao?.movimentoMovimentacao
                      ?.tipoSituacaoMovimentacao?.descricao
                  ? primeiraMovimentacao?.movimentoMovimentacao
                      ?.tipoSituacaoMovimentacao?.descricao
                  : ""
                : ""
            }
          />

          <Information
            title="Serviço de Acolhimento:"
            information={
              (data.movimentacoes[0]?.motivoSituacao?.riscoVida === "S" &&
                !permissaoServico) ||
              (!permissaoServico &&
                (data?.movimentacoes[0]?.movimentoMovimentacao?.id === 2 ||
                  data?.movimentacoes[0]?.movimentoMovimentacao?.id === 1 ||
                  data?.movimentacoes[0]?.movimentoMovimentacao?.id === 6) &&
                temRiscoVidaInfo)
                ? ""
                : data.servicoAcolhimento
                ? data.movimentacoes[0].servicoAcolhimento
                  ? data.movimentacoes[0].servicoAcolhimento.nomeFantasia
                  : ""
                : ""
            }
          />
          <Information
            title="Data de nascimento:"
            information={
              data?.dataNascimento
                ? format(data.dataNascimento, "dd/MM/yyyy") +
                  (data.dataNascimentoEstimada === "S" ? " (Estimada)" : "")
                : ""
            }
          />

          <Information
            title="Gênero:"
            information={data.genero ? data.genero.genero : ""}
          />
          <Information
            title="Raça/Cor:"
            information={data.raca ? data.raca.raca : ""}
          />
          <Information
            title="Nacionalidade:"
            information={
              data.nacionalidade ? data.nacionalidade.nacionalidade : ""
            }
          />
          <Information
            title="Naturalidade:"
            information={data.naturalidade ? data.naturalidade.nome : ""}
          />
          <Information
            title="Criança é Registrada?"
            information={
              !!data.documentacao
                ? data.documentacao?.registrada?.trim() === "S"
                  ? "Sim"
                  : data.documentacao?.registrada?.trim() === "N"
                  ? "Não"
                  : "Sem Informação"
                : "Sem Informação"
            }
          />
          <Information
            title="Filiação:"
            information={data.filiacoes
              .sort((a, b) => a.tipoFiliacao?.localeCompare(b.tipoFiliacao))
              .map((info, index) => (
                <p key={index}>
                  <Box as="span" fontWeight={700}>
                    {info.tipoFiliacao}
                    {": "}
                  </Box>
                  {info.filiacao.nome}{" "}
                  {info.filiacao.falecido === "S"
                    ? "(Falecido)"
                    : info.filiacao.idCriancaFiliacaoAcolhido
                    ? "(Acolhido(a))"
                    : ""}
                </p>
              ))}
          />
          <Information
            title="Possui irmãos?"
            information={data.possuiIrmao ? "Sim" : "Não"}
          />
          <Information
            title="Data de criação:"
            information={
              data.dataCadastro ? format(data.dataCadastro, "dd/MM/yyyy") : ""
            }
          />
          <Information
            title="Data da última atualização:"
            information={
              data.ultimaAtualizacao
                ? format(data.ultimaAtualizacao, "dd/MM/yyyy")
                : ""
            }
          />
        </Box>
      </Box>
      <Box display="block">
        <Group
          bgColor="#fff"
          title="Identificação"
          mt="0px"
          py="12px"
          mtDivider="5px"
        >
          <Information
            display={true}
            title="Nome:"
            information={data ? data?.nome : ""}
          />
          <Information
            display={true}
            title="Nome Social:"
            information={data?.nomeSocial ? data?.nomeSocial : ""}
          />
          <Information
            display={true}
            title="Data de Nascimento:"
            information={
              data?.dataNascimento
                ? format(data?.dataNascimento, "dd/MM/yyyy") +
                  (data?.dataNascimentoEstimada === "S" ? " (Estimada)" : "")
                : ""
            }
          />
          <Information
            display={true}
            title="Gênero:"
            information={data?.genero ? data.genero?.genero : ""}
          />
          <Information
            display={true}
            title="Raça/Cor:"
            information={data?.raca ? data?.raca?.raca : ""}
          />
          <Information
            display={true}
            title="Nacionalidade:"
            information={
              data?.nacionalidade ? data?.nacionalidade?.nacionalidade : ""
            }
          />
          <Information
            display={true}
            title="Naturalidade:"
            information={data?.naturalidade ? data?.naturalidade?.nome : ""}
          />
          <Information
            display={true}
            title="Tipo Sanguíneo:"
            information={
              data?.tipoSanguineo ? data?.tipoSanguineo?.tipoSanguineo : ""
            }
          />
          <Text
            mt={30}
            fontWeight={700}
            fontSize="16px"
            lineHeight="21.6px"
            color={"#169499"}
          >
            {"Filiação".toUpperCase()}
          </Text>
          <FiliacaoTableVisualizacao
            disableHeaderOptions={true}
            columns={columns}
            data={data?.filiacoes.map((filiacao) => filiacao.filiacao)}
            dataNascimentoCA={data?.dataNascimento}
          />
        </Group>
        {ocultarDocumentacao ? (
          <>
            <Group bgColor="#fff" title="Registro de Nascimento">
              {dataDocumentacao?.registrada?.trim() === "S" ? (
                <TableDocumentacao
                  columns={columnsRegistro}
                  data={[dataDocumentacao]}
                />
              ) : (
                <Text mt="25px" fontWeight={"bold"}>
                  {dataDocumentacao?.registrada?.trim() === "N"
                    ? "Não Possui"
                    : "Não Possui"}
                </Text>
              )}

              {dataDocumentacao?.numeroSolicitacaoCertNascimento && (
                <Information
                  display={"flex"}
                  title="Número de solicitação do documento ao órgão responsável:"
                  information={
                    dataDocumentacao &&
                    dataDocumentacao.numeroSolicitacaoCertNascimento
                      ? dataDocumentacao.numeroSolicitacaoCertNascimento
                      : ""
                  }
                />
              )}
            </Group>
            <Box display="break-page">
              <Flex>
                <Group bgColor="#fff" title="Identidade">
                  {dataDocumentacao?.possuiIdentidade?.trim() === "S" ? (
                    <TableDocumentacao
                      columns={columnsIdentidade}
                      data={[dataDocumentacao]}
                    />
                  ) : (
                    <Text mt="25px" fontWeight={"bold"}>
                      {dataDocumentacao?.possuiIdentidade?.trim() === "N"
                        ? "Não Possui"
                        : "Não Possui"}
                    </Text>
                  )}
                  {dataDocumentacao?.numeroSolicitacaoIdentidade && (
                    <Information
                      display={"flex"}
                      title="Número de solicitação do documento ao órgão responsável:"
                      information={
                        dataDocumentacao &&
                        dataDocumentacao.numeroSolicitacaoIdentidade
                          ? dataDocumentacao.numeroSolicitacaoIdentidade
                          : ""
                      }
                    />
                  )}
                </Group>
              </Flex>
            </Box>
            <Box className="break-page">
              <Flex>
                <Group bgColor="#fff" title="CPF">
                  {dataDocumentacao?.possuiCpf?.trim() === "S" ? (
                    <TableDocumentacao
                      columns={columnsCPF}
                      data={[dataDocumentacao]}
                    />
                  ) : (
                    <Text mt="25px" fontWeight={"bold"}>
                      {dataDocumentacao?.possuiCpf?.trim() === "N"
                        ? "Não Possui"
                        : "Não Possui"}
                    </Text>
                  )}
                </Group>
              </Flex>
            </Box>
            {dataDocumentacao?.numeroSolicitacaoCPF && (
              <Information
                display={"flex"}
                title="Número de solicitação do documento ao órgão responsável:"
                information={
                  dataDocumentacao && dataDocumentacao.numeroSolicitacaoCPF
                    ? dataDocumentacao.numeroSolicitacaoCPF
                    : ""
                }
              />
            )}
            {(data?.dataNascimento
              ? new Date(data.dataNascimento)
              : null &&
                !isNaN(
                  (data?.dataNascimento
                    ? new Date(data.dataNascimento)
                    : null
                  ).getTime()
                )) &&
              intervalToDuration({
                start: data?.dataNascimento
                  ? new Date(data.dataNascimento)
                  : null,
                end: new Date(),
              })?.years >= 16 &&
              !!dataDocumentacao?.possuiCtps && (
                <Box display="break-page">
                  <Flex>
                    <Group bgColor="#fff" title="CTPS">
                      {dataDocumentacao?.possuiCtps?.trim() === "F" ? (
                        <TableDocumentacao
                          columns={columnsCTPS}
                          data={[dataDocumentacao]}
                        />
                      ) : (
                        <Text mt="25px" fontWeight={"bold"}>
                          {data?.possuiCtps?.trim() === "D"
                            ? "Digital: " + data.cpf
                            : data?.possuiCtps?.trim() === "N"
                            ? "Não Possui"
                            : "Não Possui"}
                        </Text>
                      )}
                    </Group>
                  </Flex>
                </Box>
              )}

            <Box className="break-page">
              <Flex>
                <Group bgColor="#fff" title="Cartão Nacional do SUS">
                  {dataDocumentacao?.possuiCartaoSus?.trim() === "S" ? (
                    <TableDocumentacao
                      columns={columnsCartaoNacionalSUS}
                      data={[dataDocumentacao]}
                    />
                  ) : (
                    <Text mt="25px" fontWeight={"bold"}>
                      {dataDocumentacao?.possuiCartaoSus?.trim() === "N"
                        ? "Não Possui"
                        : "Não Possui"}
                    </Text>
                  )}
                </Group>
              </Flex>
            </Box>

            <Box className="break-page">
              <Flex>
                <Group bgColor="#fff" title="Número de Identificação Social">
                  {dataDocumentacao?.possuiNumeroIdentidadeSocial?.trim() ===
                  "S" ? (
                    <TableDocumentacao
                      columns={columnsNumeroIdentidadeSocial}
                      data={[dataDocumentacao]}
                    />
                  ) : (
                    <Text mt="25px" fontWeight={"bold"}>
                      {dataDocumentacao?.possuiNumeroIdentidadeSocial?.trim() ===
                      "N"
                        ? "Não Possui"
                        : "Não Possui"}
                    </Text>
                  )}
                </Group>
              </Flex>
            </Box>
          </>
        ) : (
          ""
        )}
      </Box>
    </HStack>
  ) : (
    <Box className="block">
      <Group
        bgColor="#fff"
        title="Dados principais"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
